import type { FaireProductEntity } from "../../entity_types/product";

export const p_r2bns6ad7n: FaireProductEntity = {
  token: "p_r2bns6ad7n",
  type: "product",
  name: "Dominoes - Classic Mangowood Game Set",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/2debf4397260ddc9ac75d3408ef8faaf7a60d97023a692251f6bba54651577dd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/60a154a1ad7287bfba86ed6f335cdf0fb9b6a5aa80a82a48c56e573cd42fc399.jpeg",
    "https://cdn.faire.com/fastly/a4e20aad9c1ffca17d13b4adc276b5e6458d4135f0aba5dd29e3d3e59aa5a649.jpeg",
    "https://cdn.faire.com/fastly/4e4974c17cc990195bddcbf7e001f4e3f4dcdc0e2b4c46c2ec980a020514b6b8.jpeg",
    "https://cdn.faire.com/fastly/4fbe311733d0d9ba6a78f6bc754b58e4e32427da60ddc508e2046fdd48705e1e.jpeg",
    "https://cdn.faire.com/fastly/f62b2fceec7f8a11ac8f6c48caca6037ea8d4b8f9b8816f7681db011912fdc87.jpeg",
    "https://cdn.faire.com/fastly/0e1db66ea83b8fe86e3e5899a2b161f948fbb9e5027d83d232981bc1fcdc371a.jpeg",
  ],
  priceDollars: 17.5,
  description:
    "Handcrafted in Thailand from mango wood, this Dominoes Set is both a timeless game and a decorative accent. Perfect for family game nights or coffee table décor, it makes a unique artisan-made gift that blends playfulness with craftsmanship.\n\nMaterial – Locally sourced mango wood, handcrafted in Thailand\n\nDesign – Complete domino set with carved wooden tiles\n\nUse – Ideal for game nights, family fun, or coffee table décor\n\nGiftable – A unique artisan-made gift for any occasion",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:26.242Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
